import { Button, Typography } from '@globalmed/atlas-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styles from './PageNotFound.module.css';
import { useUsersStore } from '@/stores/users';
import { EKioskRouterNames, ERouterNames } from '@/types';
import { homepageByRole } from '@/utils/constants';
import { checkIsKiosk } from '@/utils/kiosk';

const PageNotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const role = useUsersStore((state) => state.role);

  const getUrlToRedirect = () => {
    const isKiosk = checkIsKiosk();
    if (isKiosk) {
      return EKioskRouterNames.KIOSK;
    }
    if (!role) {
      return ERouterNames.BASE;
    }
    return homepageByRole[role];
  };

  return (
    <div className={styles.wrapper}>
      <img className={styles.leftBottom} src="/images/left-bottom.svg" alt="" />
      <img className={styles.rightTop} src="/images/right-top.svg" alt="" />

      <Typography
        as="div"
        aria-hidden="true"
        fontSize="40px"
        fontWeight="700"
        color={'var(--colors-primary600)'}
        sx={{ lineHeight: '60px' }}
      >
        404
      </Typography>

      <Typography
        as="h1"
        fontSize="32px"
        fontWeight="600"
        color={'var(--colors-gray950)'}
        mb="8px"
        sx={{ lineHeight: '48px' }}
      >
        {t('page-not-found.page-not-found')}
      </Typography>

      <Typography
        className={styles.text}
        as="p"
        fontSize="16px"
        fontWeight="400"
        color={'var(--colors-secondary)'}
        mb="22px"
        sx={{ lineHeight: '24px', textAlign: 'center' }}
      >
        {t('page-not-found.sorry-we-cant-find-the-page-youre-looking-for')}
      </Typography>

      <Button
        variant="primary"
        text={t('page-not-found.go-to-homepage')}
        onClick={() => navigate(getUrlToRedirect())}
      />
    </div>
  );
};

export default PageNotFound;
